/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface SchemaUpdateLog { 
    logType: SchemaUpdateLog.LogTypeEnum;
    message: string;
}
export namespace SchemaUpdateLog {
    export type LogTypeEnum = 'ERROR' | 'WARNING' | 'SUCCESS' | 'INFO';
    export const LogTypeEnum = {
        Error: 'ERROR' as LogTypeEnum,
        Warning: 'WARNING' as LogTypeEnum,
        Success: 'SUCCESS' as LogTypeEnum,
        Info: 'INFO' as LogTypeEnum
    };
}


